import React, {Component, Fragment} from 'react';
import {Link} from 'react-router-dom';
import Dropzone from 'react-dropzone';
import toastr from 'toastr';
import axios from 'axios';

export default class Uploader extends Component {

    constructor(props){
        super(props);
        this.state = {
            images : [],
            albums: [],
            album_id: '',
            progress : 0,
            uploading : true,
            supported_mime : [
                'image/jpeg',
                'image/png',
            ]
        }
    }

    componentDidMount() {
        axios.get('album-collection')
            .then(res => {
                this.setState({
                    albums: res.data
                });
            }).catch(e => console.log(e));
    }

    onDrop(images){
        this.setState({
            images : this.state.images.concat([...images])
        });
    }

    onChange(e) {
        this.setState({
            album_id: e.target.value
        });
    }

    onDropRejected(images){
        if(images.length){
            toastr.error('Please upload valid image files. Supported extension JPEG and PNG', 'Invalid MIME type');
        }
    }

    removeDroppedFile(preview, e = null){
        this.setState({
            images : this.state.images.filter((image) => {
                return image.preview !== preview
            })
        })
    }

    uploadFiles(){
        let images = this.state.images,
            album_id = this.state.album_id,
            config = { headers: { 'Content-Type': 'multipart/form-data' } },
            total_files = this.state.images.length,
            uploaded = 0;

        this.setState({
            uploading : true
        });

        images.map((image) => {
            let formData = new FormData();
            formData.append("file", image);
            formData.append("album_id", album_id);

            console.log(formData);
            axios.post("/photos", formData, config)
            .then(res => {
                if(res.data){
                    this.removeDroppedFile(image.preview);
                    return this.calculateProgress(total_files, ++uploaded);
                }
            })
            .catch(e => {
                this.removeDroppedFile(image.preview);
                toastr.error('You must create an album first', 'Invalid Request');
            });
        });
    }

    calculateProgress(total, uploaded){
        let percentage = (uploaded / total) * 100;
        this.setState({
            progress : percentage,
            uploading : percentage !== 100
        });

        if(percentage === 100){
            toastr.success('Images uploaded to gallery');
        }
    }

    render() {
        return (
            <div className="uploader">
                <div className="text-center">
                    <div className="container">
                    {this.state.albums.length ?
                        <div className="form-group text-center">
                            <label htmlFor="album_title">Album title</label>
                            <select name="album"
                                type="text"
                                name="album_id"
                                className="form-control"
                                onChange={this.onChange.bind(this)}>
                                <option defaultValue="Choose">Choose an album</option>
                                {this.state.albums.map(album => {
                                    return (
                                        <option
                                            value={album.id}
                                            key={album.id}
                                            >{album.title}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                   :
                       <div className="alert alert-danger">
                            <h1 className="text-danger">You Must Create an album first</h1>
                            <Link to="/album/create">Create an album now</Link>
                       </div>
                    }
                    </div>
                    <Dropzone
                        onDropAccepted={this.onDrop.bind(this)}
                        onDropRejected={this.onDropRejected.bind(this)}
                        className="btn btn-dark"
                        accept={this.state.supported_mime}
                    >
                        Select Images
                    </Dropzone>

                    {this.state.images.length > 0 &&
                        <button
                            className="btn btn-dark uploadBtn"
                            onClick={this.uploadFiles.bind(this)}
                        >
                            Upload
                        </button>
                    }
                </div>
                {this.state.images.length ?
                    <Fragment>
                        {this.state.uploading &&
                            <div className="progress">
                                <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{width : this.state.progress}}
                                    aria-valuenow={this.state.progress}
                                    aria-valuemin="0"
                                    aria-valuemax="100"/>
                            </div>
                        }

                        <div className="images">
                            {
                                this.state.images.map((file) =>
                                    <div key={file.preview} className="image">
                                        <span
                                            className="close"
                                            onClick={this.removeDroppedFile.bind(this, file.preview)}
                                        >X</span>
                                        <img src={file.preview} alt=""/>
                                    </div>
                                )
                            }
                        </div>
                    </Fragment>
                    :
                    <div className="no-images">
                        <h5 className="text-center">
                            Selected images will appear here
                        </h5>
                    </div>
                }
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/Uploader.js